// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `code[class*="language-"],
pre[class*="language-"] {
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  color: #eee;
  background: #2f2f2f;
  font-family: Roboto Mono, monospace;
  font-size: 1em;
  line-height: 1.5em;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

code[class*="language-"]::-moz-selection,
pre[class*="language-"]::-moz-selection,
code[class*="language-"] ::-moz-selection,
pre[class*="language-"] ::-moz-selection {
  background: #363636;
}

code[class*="language-"]::selection,
pre[class*="language-"]::selection,
code[class*="language-"] ::selection,
pre[class*="language-"] ::selection {
  background: #363636;
}

:not(pre) > code[class*="language-"] {
  white-space: normal;
  border-radius: 0.2em;
  padding: 0.1em;
}

pre[class*="language-"] {
  overflow: auto;
  position: relative;
  margin: 0.5em 0;
  padding: 1.25em 1em;
}

.language-css > code,
.language-sass > code,
.language-scss > code {
  color: #fd9170;
}

[class*="language-"] .namespace {
  opacity: 0.7;
}

.token.atrule {
  color: #c792ea;
}

.token.attr-name {
  color: #ffcb6b;
}

.token.attr-value {
  color: #a5e844;
}

.token.attribute {
  color: #a5e844;
}

.token.boolean {
  color: #c792ea;
}

.token.builtin {
  color: #ffcb6b;
}

.token.cdata {
  color: #80cbc4;
}

.token.char {
  color: #80cbc4;
}

.token.class {
  color: #ffcb6b;
}

.token.class-name {
  color: #f2ff00;
}

.token.comment {
  color: #616161;
}

.token.constant {
  color: #c792ea;
}

.token.deleted {
  color: #ff6666;
}

.token.doctype {
  color: #616161;
}

.token.entity {
  color: #ff6666;
}

.token.function {
  color: #c792ea;
}

.token.hexcode {
  color: #f2ff00;
}

.token.id {
  color: #c792ea;
  font-weight: bold;
}

.token.important {
  color: #c792ea;
  font-weight: bold;
}

.token.inserted {
  color: #80cbc4;
}

.token.keyword {
  color: #c792ea;
}

.token.number {
  color: #fd9170;
}

.token.operator {
  color: #89ddff;
}

.token.prolog {
  color: #616161;
}

.token.property {
  color: #80cbc4;
}

.token.pseudo-class {
  color: #a5e844;
}

.token.pseudo-element {
  color: #a5e844;
}

.token.punctuation {
  color: #89ddff;
}

.token.regex {
  color: #f2ff00;
}

.token.selector {
  color: #ff6666;
}

.token.string {
  color: #a5e844;
}

.token.symbol {
  color: #c792ea;
}

.token.tag {
  color: #ff6666;
}

.token.unit {
  color: #fd9170;
}

.token.url {
  color: #ff6666;
}

.token.variable {
  color: #ff6666;
}
`, "",{"version":3,"sources":["webpack://./src/shared/CodeField/style.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;;EAElB,gBAAgB;EAChB,cAAc;EACd,WAAW;;EAEX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["code[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n  text-align: left;\r\n  white-space: pre;\r\n  word-spacing: normal;\r\n  word-break: normal;\r\n  word-wrap: normal;\r\n  color: #eee;\r\n  background: #2f2f2f;\r\n  font-family: Roboto Mono, monospace;\r\n  font-size: 1em;\r\n  line-height: 1.5em;\r\n\r\n  -moz-tab-size: 4;\r\n  -o-tab-size: 4;\r\n  tab-size: 4;\r\n\r\n  -webkit-hyphens: none;\r\n  -moz-hyphens: none;\r\n  -ms-hyphens: none;\r\n  hyphens: none;\r\n}\r\n\r\ncode[class*=\"language-\"]::-moz-selection,\r\npre[class*=\"language-\"]::-moz-selection,\r\ncode[class*=\"language-\"] ::-moz-selection,\r\npre[class*=\"language-\"] ::-moz-selection {\r\n  background: #363636;\r\n}\r\n\r\ncode[class*=\"language-\"]::selection,\r\npre[class*=\"language-\"]::selection,\r\ncode[class*=\"language-\"] ::selection,\r\npre[class*=\"language-\"] ::selection {\r\n  background: #363636;\r\n}\r\n\r\n:not(pre) > code[class*=\"language-\"] {\r\n  white-space: normal;\r\n  border-radius: 0.2em;\r\n  padding: 0.1em;\r\n}\r\n\r\npre[class*=\"language-\"] {\r\n  overflow: auto;\r\n  position: relative;\r\n  margin: 0.5em 0;\r\n  padding: 1.25em 1em;\r\n}\r\n\r\n.language-css > code,\r\n.language-sass > code,\r\n.language-scss > code {\r\n  color: #fd9170;\r\n}\r\n\r\n[class*=\"language-\"] .namespace {\r\n  opacity: 0.7;\r\n}\r\n\r\n.token.atrule {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.attr-name {\r\n  color: #ffcb6b;\r\n}\r\n\r\n.token.attr-value {\r\n  color: #a5e844;\r\n}\r\n\r\n.token.attribute {\r\n  color: #a5e844;\r\n}\r\n\r\n.token.boolean {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.builtin {\r\n  color: #ffcb6b;\r\n}\r\n\r\n.token.cdata {\r\n  color: #80cbc4;\r\n}\r\n\r\n.token.char {\r\n  color: #80cbc4;\r\n}\r\n\r\n.token.class {\r\n  color: #ffcb6b;\r\n}\r\n\r\n.token.class-name {\r\n  color: #f2ff00;\r\n}\r\n\r\n.token.comment {\r\n  color: #616161;\r\n}\r\n\r\n.token.constant {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.deleted {\r\n  color: #ff6666;\r\n}\r\n\r\n.token.doctype {\r\n  color: #616161;\r\n}\r\n\r\n.token.entity {\r\n  color: #ff6666;\r\n}\r\n\r\n.token.function {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.hexcode {\r\n  color: #f2ff00;\r\n}\r\n\r\n.token.id {\r\n  color: #c792ea;\r\n  font-weight: bold;\r\n}\r\n\r\n.token.important {\r\n  color: #c792ea;\r\n  font-weight: bold;\r\n}\r\n\r\n.token.inserted {\r\n  color: #80cbc4;\r\n}\r\n\r\n.token.keyword {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.number {\r\n  color: #fd9170;\r\n}\r\n\r\n.token.operator {\r\n  color: #89ddff;\r\n}\r\n\r\n.token.prolog {\r\n  color: #616161;\r\n}\r\n\r\n.token.property {\r\n  color: #80cbc4;\r\n}\r\n\r\n.token.pseudo-class {\r\n  color: #a5e844;\r\n}\r\n\r\n.token.pseudo-element {\r\n  color: #a5e844;\r\n}\r\n\r\n.token.punctuation {\r\n  color: #89ddff;\r\n}\r\n\r\n.token.regex {\r\n  color: #f2ff00;\r\n}\r\n\r\n.token.selector {\r\n  color: #ff6666;\r\n}\r\n\r\n.token.string {\r\n  color: #a5e844;\r\n}\r\n\r\n.token.symbol {\r\n  color: #c792ea;\r\n}\r\n\r\n.token.tag {\r\n  color: #ff6666;\r\n}\r\n\r\n.token.unit {\r\n  color: #fd9170;\r\n}\r\n\r\n.token.url {\r\n  color: #ff6666;\r\n}\r\n\r\n.token.variable {\r\n  color: #ff6666;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
